<template>
  <div @click="openBrowser" :data-event-tracking="dataEventTracking">
    <slot></slot>
  </div>
</template>

<script>
import { FirebaseAnalytics } from '@/utils/firebase-analytics-wrapper';
import { trackEvent } from '@/utils/mixpanel';
export default {
  name: 'InAppBrowser',
  props: {
    href: {
      type: String,
    },
    dataEventTracking: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
  },
  methods: {
    getPage() {
      if (this.page) return this.page;
      return this.$route.path.split('/').pop();
    },
    openBrowser() {
      FirebaseAnalytics.logEvent({
        name: 'click_button',
        params: {
          button_name: this.dataEventTracking,
          page: this.getPage(),
        },
      });
      trackEvent('Button Clicked', { button_name: this.dataEventTracking, page: this.getPage() });
      this.$emit('log-event');
      this.$router.push(`/url?q=${encodeURIComponent(this.href)}&from=${this.$route.path}`);
    },
  },
};
</script>
